<template>
  <div id="listado-usuarios-contratistas-desktop">
    <v-data-table :headers="headers" :items="listadoUsuariosContratistas" :items-per-page="20">
      <template v-slot:[`item.estatus`]="{ item }">
        <v-switch
          v-model="item.estatus"
          :true-value="1"
          :false-value="2"
          inset
          @change="preCambiarEstatus(item)"
        >
        </v-switch>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :usuario="item"> </opciones>
      </template>
    </v-data-table>
    <v-dialog
      v-if="usuarioSeleccionado"
      v-model="editarUsuarioDialog"
      width="600">
      <v-card>
        <v-card-title class="secondary--text">
          Cambiar Estatus Usuario
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarEditarUsuarioDialog">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
            cols="12"
            v-model="comentarios"
            label="Comentarios"
            autoGrow>
          </custom-text-area>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarEditarUsuarioDialog"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="cambiarEstatus"
            :disabled="enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ACTUALIZAR_ESTATUS_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarEstatusUsuario.gql';
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoUsuariosContratistasDesktop',
  props: {
    listadoUsuariosContratistas: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomTextArea,
    CustomButton,
    Opciones,
  },
  data() {
    return {
      enviandoFormulario: false,
      headers: [
        { text: 'Razón Social', value: 'contratista.nombreRazonSocial', sortable: false },
        { text: 'Correo', value: 'correoElectronico', sortable: false },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Comentarios', value: 'comentarios', sortable: false },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
      usuarioSeleccionado: null,
      editarUsuarioDialog: false,
      comentarios: null,
    };
  },
  methods: {
    cerrarEditarUsuarioDialog() {
      this.editarUsuarioDialog = true;
      this.comentarios = null;
      this.usuarioSeleccionado = null;
    },
    preCambiarEstatus(usuarioEditar) {
      this.usuarioSeleccionado = usuarioEditar;
      this.editarUsuarioDialog = true;
    },
    cambiarEstatus() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { id, estatus } = this.usuarioSeleccionado;
      const usuario = {
        estatus: !estatus ? 2 : estatus,
        comentarios: this.comentarios,
      };
      this.$apollo
        .mutate({
          mutation: ACTUALIZAR_ESTATUS_USUARIO,
          variables: { id, usuario },
          update: (cache, { data: { actualizarEstatusUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios.findIndex((item) => item.id === id);
            usuarios.splice(index, 1, actualizarEstatusUsuario);
            cache.writeQuery({ query: USUARIOS, data });
            this.cerrarEditarUsuarioDialog();
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
